import axios from 'axios'

/**
 * @desc Creates new account / supplier store
 */
export const createSupplier = (request) =>
  axios.post('/public/supplier', request).then((res) => res.data)

/**
 * @desc Verifies if email is already registered
 * @desc doesEmailExist in BFF
 */
export const checkEmailExists = (request) =>
  axios.post('/public/supplier/email-existing', request).then((res) => res.data)

/**
 * @desc Verifies if ABN is valid
 * @desc isValidABN in BFF
 */
export const checkAbnValid = (request) =>
  axios.post('/public/supplier/abn-valid', request).then((res) => res.data)

/**
 * @desc Fetches Supplier details
 */
export const fetchProfile = (supplierId) =>
  axios.get(`/authenticated/supplier/${supplierId}`).then((res) => res.data)

/**
 * @desc Updates Supplier details
 */
export const updateProfile = (supplierId, request) =>
  axios
    .put(`/authenticated/supplier/${supplierId}`, request)
    .then((res) => res.data)
